import React from "react";
import { Field } from "redux-form";
import { renderField } from "../../../../Components/Forms/renders";

const HeaderFields = ({ fields }) => {
  return (
    <div className="header-fields">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>Headers</h5>
        <button 
          type="button" 
          className="btn btn-success btn-sm" 
          onClick={() => fields.push({})}
        >
          <i className="fa fa-plus"></i> Header toevoegen
        </button>
      </div>
      
      {fields.map((header, index) => (
        <div key={index} className="card mb-2">
          <div className="card-body">
            <div className="row">
              <div className="col-md-5">
                <Field
                  name={`${header}.name`}
                  component={renderField}
                  type="text"
                  label="Header naam"
                  placeholder="bijv. Authorization, Content-Type"
                />
              </div>
              <div className="col-md-6">
                <Field
                  name={`${header}.value`}
                  component={renderField}
                  type="text"
                  label="Header waarde"
                  placeholder="bijv. Bearer token, application/json"
                />
              </div>
              <div className="col-md-1 d-flex align-items-end">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => fields.remove(index)}
                  title="Header verwijderen"
                >
                  <i className="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
      
      {fields.length === 0 && (
        <div className="text-muted text-center py-3">
          <i className="fa fa-info-circle me-2"></i>
          Geen headers gedefinieerd. Klik op "Header toevoegen" om te beginnen.
        </div>
      )}
    </div>
  );
};

export default HeaderFields;